// extracted by mini-css-extract-plugin
export var audioPlayer = "_rq-0";